export const profileStations = (state) => {
  return state.profileStations;
};
